export default __webpack_public_path__ + "static/N0109-19339a4265b261dad19d12ca05f3bdf8.png";